import { BehaviorSubject } from 'rxjs'
export default new BehaviorSubject<'pt' | 'en' | 'es'>('en')
